import { Button, Text, Group } from "@mantine/core";
import React, { useState } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { showNotification } from "@mantine/notifications";
import { openFileUrl } from "../utils/openReport";

const ReportGIInsurerOutstandingSettlement = () => {
  const [fromDate, setFromDate] = useState(() =>
    moment().startOf("month").toDate()
  );
  const [toDate, setToDate] = useState(() => moment().endOf("month").toDate());
  const [loading, setLoading] = useState(false);

  const [api] = useServerApi();
  const { t } = useTranslation();

  const canDownload = Boolean(fromDate && toDate);

  const downloadReport = async () => {
    if (!fromDate || !toDate) {
      showNotification({
        color: "red",
        message: t(
          "giSettlement.outstandingReport.dateRequired",
          "Please select both From and To dates for the insurer statement period."
        ),
      });
      return;
    }

    try {
      setLoading(true);
      const result = await api.GISettlement.getInsurerOutstandingSettlementReport(
        { fromDate, toDate }
      );
      setLoading(false);

      if (result?.success === false) {
        showNotification({
          color: "red",
          message:
            result.message ||
            t(
              "giSettlement.outstandingReport.downloadFailed",
              "Failed to download report."
            ),
        });
        return;
      }

      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "giSettlement.outstandingReport.helper",
          "Select the insurer statement date period. The report includes all imported insurer statement rows across GI settlement batches, with match coverage and overdue summary."
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder={t("From Date")}
          required
          value={fromDate}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder={t("To Date")}
          required
          value={toDate}
          onChange={(d) => setToDate(d)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportGIInsurerOutstandingSettlement;
